import React, { useEffect, useRef, useState } from 'react';
import { ICompany } from 'src/entities/company';
import objectFitImages from 'object-fit-images';
import classNames from 'classnames';
import Nl2br from '../Nl2br/Nl2br';

interface IHeroSectionProps {
    company: ICompany;
}

const HeroSection: React.FC<IHeroSectionProps> = ({ company }) => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [hasBackground, setHasBackground] = useState(!!company.BackgroundLink);
    const [hasLogo, setHasLogo] = useState(!!company.LogoLink);
    const hasDescription = !!company.ShortDescription;
    const detailsClasses = classNames('hero-section__details', {
        'hero-section__details--has-background': hasBackground,
    });

    useEffect(() => {
        if (imgRef.current) {
            objectFitImages(imgRef.current);
        }
    }, [imgRef.current]);

    const disableBackground = () => {
        setHasBackground(false);
    };

    const disableLogo = () => {
        setHasLogo(false);
    };

    return (
        <section className="hero-section">
            {hasBackground && (
                <img
                    ref={imgRef}
                    className="hero-section__background"
                    src={company.BackgroundLink}
                    alt=""
                    onError={disableBackground}
                />
            )}
            {hasLogo && (
                <div className={detailsClasses}>
                    <img
                        className="hero-section__logo"
                        src={company.LogoLink}
                        alt=""
                        onError={disableLogo}
                    />
                </div>
            )}
            {hasDescription && (
                <article className="hero-section__description">
                    <Nl2br text={company.ShortDescription} />
                </article>
            )}
        </section>
    );
};

export default HeroSection;
